export default function ShareIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  id = '',
  'aria-label': ariaLabel,
  'data-testid': dataTestId
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
  id?: string;
  'aria-label'?: string;
  'data-testid'?: string;
}) {
  return (
    <span
      className={className}
      onClick={onClick}
      id={id}
      aria-label={ariaLabel}
      data-testid={dataTestId}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <path d='M18 3C16.8954 3 16 3.89543 16 5C16 6.10457 16.8954 7 18 7C19.1046 7 20 6.10457 20 5C20 3.89543 19.1046 3 18 3ZM14 5C14 2.79086 15.7909 1 18 1C20.2091 1 22 2.79086 22 5C22 7.20914 20.2091 9 18 9C15.7909 9 14 7.20914 14 5Z' />
        <path d='M6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10ZM2 12C2 9.79086 3.79086 8 6 8C8.20914 8 10 9.79086 10 12C10 14.2091 8.20914 16 6 16C3.79086 16 2 14.2091 2 12Z' />
        <path d='M18 17C16.8954 17 16 17.8954 16 19C16 20.1046 16.8954 21 18 21C19.1046 21 20 20.1046 20 19C20 17.8954 19.1046 17 18 17ZM14 19C14 16.7909 15.7909 15 18 15C20.2091 15 22 16.7909 22 19C22 21.2091 20.2091 23 18 23C15.7909 23 14 21.2091 14 19Z' />
        <path d='M7.726 13.0065C8.00406 12.5293 8.61631 12.3679 9.09348 12.6459L15.9235 16.6259C16.4007 16.904 16.5621 17.5162 16.284 17.9934C16.006 18.4706 15.3937 18.632 14.9165 18.3539L8.08653 14.3739C7.60935 14.0959 7.44794 13.4836 7.726 13.0065Z' />
        <path d='M16.2737 6.0059C16.5521 6.4829 16.391 7.09525 15.914 7.37362L9.09403 11.3536C8.61703 11.632 8.00469 11.471 7.72632 10.994C7.44795 10.517 7.60898 9.90461 8.08598 9.62624L14.906 5.64624C15.383 5.36787 15.9953 5.5289 16.2737 6.0059Z' />
      </svg>
    </span>
  );
}
